/**
 * Progressive enhancement for free-gift options.
 * Liquid renders the markup; this custom element owns selection behavior.
 */
class T1ProductGifts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';

    this.onChange = this.onChange.bind(this);
    this.addEventListener('change', this.onChange);
    this.syncRows();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
  }

  get requiredMessage() {
    return this.getAttribute('data-gift-required') || 'Select a free gift';
  }

  get hasOptions() {
    return this.querySelectorAll('[data-bundle-gift]').length > 0;
  }

  get selectedInput() {
    return this.querySelector('[data-bundle-gift]:checked');
  }

  /**
   * Selected gift variant, or null if none is checked.
   */
  get selectedItem() {
    var input = this.selectedInput;
    if (!input) return null;

    var row = input.closest('[data-bundle-gift-row]');
    var select = row && row.querySelector('[data-bundle-gift-variant]');

    return {
      variantId: select ? select.value : input.value,
      quantity: 1
    };
  }

  onChange(event) {
    var variantSelect = event.target.closest('[data-bundle-gift-variant]');
    if (variantSelect) {
      this.syncVariant(variantSelect);
      return;
    }

    var input = event.target.closest('[data-bundle-gift]');
    if (!input) return;

    if (input.checked) {
      this.querySelectorAll('[data-bundle-gift]').forEach(function (other) {
        if (other !== input) other.checked = false;
      });
    }

    this.syncRows();
    this.dispatchEvent(new CustomEvent('product-gift:change', {
      bubbles: true,
      detail: { item: this.selectedItem }
    }));
  }

  syncVariant(select) {
    var row = select.closest('[data-bundle-gift-row]');
    var checkbox = row && row.querySelector('[data-bundle-gift]');
    var selected = select.options[select.selectedIndex];

    if (checkbox) checkbox.value = select.value;
    if (row && selected) {
      var priceEl = row.querySelector('[data-bundle-gift-price]');
      var price = selected.getAttribute('data-price');
      if (priceEl && price) priceEl.textContent = price;
    }
  }

  syncRows() {
    this.querySelectorAll('[data-bundle-gift]').forEach(function (input) {
      var row = input.closest('[data-bundle-gift-row]');
      if (!row) return;
      row.classList.toggle('border-black', input.checked);
      row.classList.toggle('border-transparent', !input.checked);
    });
  }
}

if (!customElements.get('t1-product-gifts')) {
  customElements.define('t1-product-gifts', T1ProductGifts);
}
